// src/modules/guest/routes/index.ts
import type { RouteRecordRaw } from 'vue-router'
import { registrationRoutes } from '../registration/routes'

export const guestRoutes: RouteRecordRaw[] = [
  {
    path: '/guest',
    component: () => import('@/modules/guest/layouts/Main.vue'),
    children: [
      {
        path: '',
        name: 'guest',
        meta: { public: false },
        component: () => import('@/modules/guest/views/Home.vue'),
      },
      {
        path: 'event/:eventId',
        name: 'guest-eventLp',
        component: () => import('@/modules/guest/views/LandingPagePrivate.vue'),
        meta: { public: false },
      },
      {
        path: 'accept-form/:inviteKey',
        name: 'guest-accept-invite',
        component: () =>
          import('@/modules/guest/registration/views/FormInvite.vue'),
        meta: { public: false },
      },

      // ✅ AGORA SIM: dentro de children
      ...registrationRoutes,
    ],
  },
]
